
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

/* Actions */
import { updateUserProfile, updateUserDocuments } from "../../../../redux/actions/user";
import { setProfileBuilderFinishLine, setAlert } from "../../../../redux/actions/misc";

/* Components */
import DashboardSectionBase from "../../../../components/DashboardSectionBase";
import DocumentSection from "../../../../components/DocumentSection";
import SaveButton from "../../../../components/SaveButton";
import CVRepopulateModal from "../../../../components/CVRepopulateModal";

/* Helpers */
import { bytesToSize } from "../../../../helpers/misc";

/* API requests */
import { uploadUpdatedCV, uploadDocument, updateCandidate, parseCVForProfile } from "../../../../api-requests/candidate";

class Documents extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currentlyLoading: "",
            name: "",
            extension: "",
            size: "",
            showCvRepopulateModal: false,
            applyingCvRepopulate: false,
            // Holds the parse result until the user clicks Continue, so the
            // game inside the modal can keep playing after parsing finishes.
            pendingRepopulateResult: null,
        };

    }

    componentDidMount() {

        return document.getElementById("Dashboard").scrollTo(0, 0);

    }

    handleDocumentRemove = (propName, index) => {

        const { profile } = this.props.user.data;

        let body;

        if (propName !== "cv") {
            const newArray = profile[propName].filter((_, idx) => idx !== index);
                body = [ { propName: propName, value: newArray } ];
        } else {
            body = [ { propName: propName, value: null } ];
        }

        return updateCandidate(profile._id, body)
            .then(result => {
                return this.props.updateUserProfile(result.data);
            });

    }

    handleDocumentUpload = (files, propName) => {

        if (files && files[0]) {

            const filesArray = [...files];

            if (propName !== "cv") {

                const placeholders = filesArray.map((file, index) => {

                    const dotIndex = file.name.indexOf(".");

                    const name = file.name.slice(0, dotIndex),
                        extension = file.name.slice(dotIndex),
                        size = bytesToSize(file.size);

                    return {
                        id: index,
                        loading: true,
                        name,
                        extension,
                        size,
                    };

                });

                this.props.updateUserProfile([{ propName: propName, value: [...this.props.user.data.profile[propName], ...placeholders] }]);

            } else {

                const dotIndex = filesArray[0].name.indexOf(".");

                const name = filesArray[0].name.slice(0, dotIndex),
                    extension = filesArray[0].name.slice(dotIndex),
                    size = bytesToSize(filesArray[0].size);

                this.props.updateUserProfile([{ propName: propName, value: { name: name, extension: extension, size: size, loading: true } }]);

            }

            filesArray.forEach((file, index) => {

                const dotIndex = file.name.indexOf(".");

                const name = file.name.slice(0, dotIndex),
                    extension = file.name.slice(dotIndex),
                    size = bytesToSize(file.size);

                if (propName !== "cv") {
                    return uploadDocument(this.props.user.data.profile._id, name, extension, size, propName, file)
                        .then(result => {
                            return this.handleResult(propName, result, index);
                        });
                } else {
                    return uploadUpdatedCV(this.props.user.data.profile._id, name, extension, size, file)
                        .then(result => {
                            return this.handleResult(propName, result);
                        });
                }

            });

        }

    }

    handleResult = (propName, result, index) => {

        const { profile } = this.props.user.data;

        if (propName !== "cv") {
            if (result.status === 201) {
                return this.props.updateUserDocuments(propName, index, result.data);
            } else {
                this.props.setAlert(result.error_message || "Document upload failed. Please try again.", "error", true);
                const newArray = profile[propName].reverse().filter((_, idx) => idx !== index);
                return this.props.updateUserProfile([{ propName: propName, value: newArray }]);
            }
        } else {
            if (result.status === 201) {
                this.props.updateUserProfile([{ propName: propName, value: result.data }]);
                return this.setState({ showCvRepopulateModal: true });
            } else {
                this.props.setAlert(result?.error_message || "CV upload failed. Please try again.", "error", true);
                return this.props.updateUserProfile([{ propName: propName, value: null }]);
            }
        }

    }

    handleApplyCvRepopulate = () => {

        const candidateId = this.props.user.data.profile._id;

        this.setState({ applyingCvRepopulate: true, pendingRepopulateResult: null }, () => {
            return parseCVForProfile(candidateId)
                .then(result => {
                    if (result && result.status === 201 && Array.isArray(result.body)) {
                        return this.setState({
                            applyingCvRepopulate: false,
                            pendingRepopulateResult: result.body,
                        });
                    }
                    this.props.setAlert(result?.error_message || "Couldn't read your CV. Please try again.", "error", true);
                    return this.setState({ showCvRepopulateModal: false, applyingCvRepopulate: false });
                });
        });

    }

    handleContinueRepopulate = () => {
        const { pendingRepopulateResult } = this.state;
        if (!pendingRepopulateResult) return;
        this.props.updateUserProfile(pendingRepopulateResult);
        this.props.setAlert("Profile updated from your CV.", "success", true);
        // CV replaced and changes applied - take them straight to the refreshed
        // CV preview. Navigating unmounts this page (and the modal with it).
        return this.props.history.push("/profile/cv");
    }

    handleSkipCvRepopulate = () => {
        return this.setState({ showCvRepopulateModal: false });
    }

    render() {

        const { profile } = this.props.user.data;

        return(
            <>
                <DashboardSectionBase title={"Documents"} subtitle="Certificates and paperwork captains expect to see.">
                    <DocumentSection title={"Updated CV"} profile={profile} state={this.state} handleDocumentUpload={this.handleDocumentUpload} propName={"cv"} handleDocumentRemove={this.handleDocumentRemove} />
                    <DocumentSection title={"Travel Documents (Passport/Visas)"} profile={profile} state={this.state} handleDocumentUpload={this.handleDocumentUpload} propName={"travelDocument"} handleDocumentRemove={this.handleDocumentRemove} />
                    <DocumentSection title={"STCW Basic Safety Training"} profile={profile} state={this.state} handleDocumentUpload={this.handleDocumentUpload} propName={"stcwBasic"} handleDocumentRemove={this.handleDocumentRemove} />
                    <DocumentSection title={"ENG 1"} profile={profile} state={this.state} handleDocumentUpload={this.handleDocumentUpload} propName={"eng1"} handleDocumentRemove={this.handleDocumentRemove} />
                    <DocumentSection title={"Licenses & CoCs (If Applicable)"} profile={profile} state={this.state} handleDocumentUpload={this.handleDocumentUpload} propName={"license"} handleDocumentRemove={this.handleDocumentRemove} />
                    <DocumentSection title={"STCW Advanced Safety Training (If Applicable)"} profile={profile} state={this.state} handleDocumentUpload={this.handleDocumentUpload} propName={"stcwAdvanced"} handleDocumentRemove={this.handleDocumentRemove} />
                    <DocumentSection title={"Written References"} profile={profile} state={this.state} handleDocumentUpload={this.handleDocumentUpload} propName={"writtenReferences"} handleDocumentRemove={this.handleDocumentRemove} />
                    <DocumentSection title={"Other Certificates/Documents"} profile={profile} state={this.state} handleDocumentUpload={this.handleDocumentUpload} propName={"allDocuments"} handleDocumentRemove={this.handleDocumentRemove} />
                </DashboardSectionBase>
                <SaveButton propNames={[]} profile={profile} updateUserProfile={this.props.updateUserProfile} previous={"/profile/references"} next={"/profile/documents"} history={this.props.history} complete={true} setFinishLine={this.props.setProfileBuilderFinishLine} />
                <CVRepopulateModal
                    show={this.state.showCvRepopulateModal}
                    applying={this.state.applyingCvRepopulate}
                    profileReady={!!this.state.pendingRepopulateResult}
                    onApply={this.handleApplyCvRepopulate}
                    onSkip={this.handleSkipCvRepopulate}
                    onContinue={this.handleContinueRepopulate}
                />
            </>
        );

    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        ...bindActionCreators({ updateUserProfile, updateUserDocuments, setProfileBuilderFinishLine, setAlert }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Documents);